__turbopack_context__.v({
  "cols": "simpleList-module-scss-module__I1wr9G__cols",
  "icon": "simpleList-module-scss-module__I1wr9G__icon",
  "illustration": "simpleList-module-scss-module__I1wr9G__illustration",
  "largeGap": "simpleList-module-scss-module__I1wr9G__largeGap",
  "listWrapper": "simpleList-module-scss-module__I1wr9G__listWrapper",
  "simpleList": "simpleList-module-scss-module__I1wr9G__simpleList",
});
